import { defineComponent as _defineComponent } from 'vue'
import { ASSISTANT_BUBBLE_Z_INDEX } from './constants'


export default /*#__PURE__*/_defineComponent({
  __name: 'g-assistant-bubble',
  props: {
  /** 面板是否展开，仅用于入口高亮反馈 */
  active: {
    type: Boolean,
    default: false,
  },
},
  emits: ['toggle'],
  setup(__props, { emit: emits }) {





return { __sfc: true,emits, ASSISTANT_BUBBLE_Z_INDEX }
}

})